import React, { useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { PasswordStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { Icons } from "components";

const Password = ({
  theme_standard,
  theme_standard2,
  theme_br50,
  label,
  errors,
  disabled,
  isRequire,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const customClass = cx({
    theme_standard: theme_standard,
    theme_standard2: theme_standard2,
  });

  const { t } = useTranslation(["common"]);
  return (
    <PasswordStyled className={customClass} disabled={disabled}>
      {label && (
        <div className="label">
          {label} {isRequire && <span> *</span>}
        </div>
      )}
      <div className="password_input">
        <input {...props} type={showPassword ? "text" : "password"} disabled={disabled} />
        <div className="eye" onClick={() => setShowPassword(!showPassword)}>
          <Icons.Eye color={showPassword ? "#4B247E" : "#A0A0A0"}/>
        </div>
      </div>
      {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
    </PasswordStyled>
  );
};

Password.propTypes = {};

export default Password;
